package com.milta.feature.auth.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class OtpVerifyRequest(val phoneNumber: String, val code: String)
